import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import { withStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import TableCell from '@material-ui/core/TableCell';
import { SoxService } from '../../services/bunkermaster/SoxService';
import { toast } from 'react-toastify';
import {
    FormHelperText,
    Input,
    InputLabel,
    InputBase,
} from "@material-ui/core";

import HelpIcon from '@material-ui/icons/Help';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const BootstrapInput = withStyles((theme) => ({
    root: {
        "label + &": {
            marginTop: theme.spacing(2),
        },
    },

    input: {
        borderRadius: 4,
        position: "relative",
        backgroundColor: theme.palette.common.white,
        border: "1px solid #ced4da",
        fontSize: 16,
        width: "auto",
        padding: "10px 12px",
        height: "0.1876em",
        // marginLeft: '2.2em',
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
        "&:focus": {
            // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main,
        },
    },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    btn1: {
        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '0 !important',
        fontSize: '16px; font-weight: normal',
        padding: '8px 15px',
        width: '130px !important'

    },
    btn2: {

        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '20px !important',
        fontSize: '16px; font-weight: normal',
        padding: '8px 15px',
        width: '130px !important'
    },
    textstyles: {
        color: '#ff4717'
    }
}));

function SosCalculation() {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [Sox, setSOX] = React.useState('')
    const [sulphurFields, setSulphurFields] = React.useState({ sulphur: "", bunkerqty: "" })
    const [fieldClass, setFieldClass] = React.useState({ sulphur: true, bunkerqty: true });

    const [open, setOpen] = React.useState(false);
    const [scroll, setScroll] = React.useState('paper');

     const handleClickOpen = (scrollType) => () => {
        setOpen(true);
        setScroll(scrollType);
        };

        const handleClose = () => {
            setOpen(false);
        };

        const descriptionElementRef = React.useRef(null);
        React.useEffect(() => {
            if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
            }
        }, [open]);

    // const [fieldClass, setFieldClass] = React.useState( true );
    // const [fieldClass1, setFieldClass1] = React.useState( true );
   
    const Calculation = () => {
        ;
        //  if (sulphurFields["sulphur"] === "") {
        //     setFieldClass(false)

        // }
        //  if (sulphurFields["bunkerqty"] === "") {
        //     setFieldClass1(false)
        // }
        if (sulphurFields["sulphur"] === "") {
            let update = fieldClass;
            update["sulphur"] = false;
            setFieldClass({ ...fieldClass, ...update })
        }
        if (sulphurFields["bunkerqty"] === "") {
            let update = fieldClass;
            update["bunkerqty"] = false;
            setFieldClass({ ...fieldClass, ...update })
        }
        let result = SoxService.CalculateSox(
            sulphurFields
        )
        setSOX(result)
    }

    const onValuesChange = (value, field) => {
        
        let local = sulphurFields;
        local[field] = value;
        setSulphurFields({ ...sulphurFields, ...local });

        // if (sulphurFields["sulphur"] !== "") {
        //     setFieldClass(true)
        // }
        //  if (sulphurFields["bunkerqty"] !== "") {
        //     setFieldClass1(true)
        // }
        if (sulphurFields["sulphur"] !== "") {
            let newupdate = fieldClass;
            newupdate["sulphur"] = true;
            setFieldClass({ ...fieldClass, ...newupdate })
        }
        if (sulphurFields["bunkerqty"] !== "") {
            let newupdate = fieldClass;
            newupdate["bunkerqty"] = true;
            setFieldClass({ ...fieldClass, ...newupdate })
        }
    }
    const onResetenergy= () => {
        //;
        setSOX('')
        setSulphurFields({...sulphurFields,...{sulphur: "", bunkerqty: "" }});
    }
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (

        <div className={classes.root}>
            <div className="mar25">
                <div className="breadcurmbg mb25">
                    <span>Bunker Master </span>
                    <span className="bcarrow">  </span>
                    <span>SOx Calculations</span>

                </div>

                <Box component="div" className="filtercontainer">
                 <Box component="div" className="pos_relative">
                <Box component="div" className="help_blk">
                    <Button onClick={handleClickOpen('paper')}> <HelpIcon /></Button>
                   
                    <Dialog
                        open={open}
                        onClose={handleClose}
                        scroll={scroll}
                        aria-labelledby="scroll-dialog-title"
                        aria-describedby="scroll-dialog-description"
                    >
                        <DialogTitle id="scroll-dialog-title">SOx Calculations</DialogTitle>
                        <DialogContent dividers={scroll === 'paper'}>
                        <DialogContentText
                            id="scroll-dialog-description"
                            ref={descriptionElementRef}
                            tabIndex={-1}
                        >
                        <p>This module performs the SOx related calculations:</p>
                         
                                   <p className="subtitle">Calculation of SOx:</p>
                                    <img className="maxwidth100"  src="/assets/images/SOX.jpg"></img><br/>
                          <p>
                              <li>Fill both Sulphur and Bunker Quantity fields to get the result.</li><br/>
                              <li>Clicking on calculate button will display the calculated results.</li><br/>
                              <li>Reset button will reset the page.</li><br/>

                              <li>Result Calculation : ((Sulphur) * (SOxFactor = "0.02025"(Internal value)) * (Bunker Quantity)).</li>
                          </p>
                         
                        
                        </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                        <Button onClick={handleClose}>Close</Button>
                        </DialogActions>
                    </Dialog>
                </Box>
                 </Box>
                    <Box component="div">
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={12}>
                                <p className="subtitle">Fuel Type</p>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Box component="div" className="bunkarinput">
                                    <Grid container spacing={3}  >
                                        <Grid item xs={12} md={4} className="padbtm0">
                                            <label for="Sulphur" className="widthauto" >Sulphur <span className="redstar">*</span> </label>
                                        </Grid>
                                        <Grid item xs={12} md={6} className="padbtm0">

                                            <BootstrapInput
                                            type="number"
                                                // variant="outlined"
                                                // error
                                                // helperText="Incorrect entry."
                                                placeholder="  "
                                                //className={fieldClass ?"mt0":"error"}
                                                className={fieldClass.sulphur ? "mt0" : "error"}
                                                onChange={(e) => onValuesChange(e.target.value, "sulphur")}
                                                value={sulphurFields.sulphur}
                                            /> &nbsp; Mass %
                                            <span className={fieldClass.sulphur ? "userinfo" : "errortext"}>  Sulphur is required.</span>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <Box component="div" className="bunkarinput">
                                    <Grid container spacing={3}  >
                                        <Grid item xs={12} md={4} className="padbtm0">
                                            <label for="Quantity" className="widthauto">Bunker Quantity <span className="redstar">*</span>  </label>
                                        </Grid>
                                        <Grid item xs={12} md={6} className="padbtm0">

                                            <BootstrapInput
                                            type="number"
                                                placeholder="  "
                                                // className={fieldClass1 ?"mt0":"error"}
                                                className={fieldClass.bunkerqty ? "mt0" : "error"}
                                                onChange={(e) => onValuesChange(e.target.value, "bunkerqty")}
                                                value={sulphurFields.bunkerqty}
                                            /> &nbsp;Tonnes
                                            <span className={fieldClass.bunkerqty ? "userinfo" : "errortext"}>Bunker Quantity  is required.</span>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <br></br><br></br>


                                <Box component="div" className="bunkarinput">
                                    <button type="reset" className={classes.btn1}  onClick={onResetenergy} >Reset</button>
                                    <button type="button" className={classes.btn2} onClick={Calculation}  >Calculate</button>{''}
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={4}>

                                <Box component="div" className="resultbox">
                                    <p>Results</p>
                                    <Box component="div" className="bunkarinput resultinner">

                                        <form className={classes.root} noValidate autoComplete="off">
                                            <Box component="div" className="padbtm25">
                                                <label className="resultLabel"> SOx  </label>
                                                <TextField id="standard-basic" value={Sox} />
                                                <span className="resultmv"> Tonnes</span>

                                            </Box>

                                        </form>
                                    </Box>



                                </Box>



                            </Grid>


                        </Grid>

                    </Box>



                </Box>










            </div>
        </div>
    );
}
export default SosCalculation;
